<template>
  <div
      v-if="isLoading"
      class="spinner-overlay"
      :class="{'transparent-background': transparentBackground}"
  >
    <div class="flex flex-col justify-center items-center gap-10">
      <ProgressSpinner
          class="size-24 app-progress-spinner"
          stroke-width="2"
          fill="transparent"
          animation-duration="0.6s"
          :aria-label="$t('label.loading')"
      />
      <div v-if="message" class="font-bold text-zinc-950 dark:text-white opacity-60">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    transparentBackground: {
      required: false,
      default: true,
      type: Boolean
    },

    message: {
      required: false,
      default: null,
      type: String,
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ])
  }
}
</script>

<style lang="scss" scoped>
.spinner-overlay {
  background-color: theme('colors.neutral.50');
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dark .spinner-overlay {
  background-color: rgba(30, 30, 30)
}

.spinner-overlay.transparent-background {
  background-color: rgba(0, 0, 0, 0.3);
}

:deep(.app-progress-spinner .p-progressspinner-circle) {
  stroke: var(--p-primary-color);
  animation: p-progressspinner-dash 1.5s ease-in-out infinite;
}
</style>
